
// viewportの設定
var viewport = document.createElement('meta');
var viewportContent;

/*
function viewPortSetting() {
  if (window.outerWidth  >= 1200) {
    viewportContent = 'width=device-width, initial-scale=1.0';
  } else {
      viewportContent = "width=320, user-scalable=yes, minimum-scale=1.0";
  }
  document.querySelector("meta[name='viewport']").setAttribute("content", viewportContent);
}

viewPortSetting();

window.addEventListener('resize', function(){
  viewPortSetting();
})

window.addEventListener('loded', function(){
  viewPortSetting();
})
*/

// ------------
// メンテナンスページの高さ調整
// if($('.maintenance').length){
//   if(window.innerWidth < 1200) {
//     document.getElementById('wrapper').style.height = window.innerHeight + 'px';
//   }
// }

var winw, winh, headerh, SCROLL;
var _this_url = location.href;

function gnavSearch(){
  var _$target = $('.gnav_saearch >a');
  var _$close = $('.btn_close');
  var _$box = $('.search_wrap');
  var _flg = false;
  var _timer;

  function loopTimer(){
    _timer = setTimeout(loopTimer, 500);
  }

  loopTimer();

  _$target.bind('mouseenter', function (){
    if ($(this).parent().hasClass('show')) {
      $(this).parent().removeClass('show');
      _$box.stop(false, false).fadeOut(300, function (){
        _flg = false;
      });
    } else {
      $(this).parent().addClass('show');
      _$box.stop(false, false).fadeIn(300, function (){
        _flg = true;
      });
    }
  });

  _$box.bind('mouseleave', function (){
    if (_flg == true) {
      _$box.stop(false, false).fadeOut(200, function (){
        _flg = false;
        $('.gnav_saearch').removeClass('show');
      });
    }
  });

}

// PCのみ
function scrollNav(){
  var scroll = $(window).scrollTop();
  if (scroll > 60) {
    $('body').addClass('nav_fixed');
  } else {
    $('body').removeClass('nav_fixed');
  }
}


var _$btn = $('.btn_pagetop');
function pageTopNav(){
  scrollHeight = $(window).scrollTop();
  var bodyScrollHeight = document.body.scrollHeight;

  if (($('.pc-contents').css('display') == 'block')) {
    var footerHeight = window.innerHeight + 50;
  } else {
    var footerHeight = window.innerHeight + 504; // 1070
  }

  if(scrollHeight < 300 ){
    $('body').removeClass('pagetop_fixed');
    _$btn.removeClass('on');
  } else {
    $('body').addClass('pagetop_fixed');
    _$btn.addClass('on');
  }

  if(scrollHeight > bodyScrollHeight - footerHeight){
    $('body').addClass('pagetop_fixed_relative');
  } else {
    $('body').removeClass('pagetop_fixed_relative');
  }
}

pageTopNav();


const smoothScroll = new SmoothScroll('a[href*="#"]', {
	speed: 1000,
	speedAsDuration: true
});


// PCのみ
function scrollNav(){
  var scroll = $(window).scrollTop();
  if (scroll > 60) {
    $('body').addClass('nav_fixed');
  } else {
    $('body').removeClass('nav_fixed');
  }
}

var timeoutId ;

window.addEventListener( "scroll", function () {
  _$btn.removeClass('on');
	clearTimeout( timeoutId ) ;
	timeoutId = setTimeout( function () {
    pageTopNav();
	}, 500 ) ;
} ) ;

function winCheck(){
  if (winw < 1200) {
    $('body').addClass('win_under1200');
  } else {
    $('body').removeClass('win_under1200');
  }
}

// PC / SP 共通
function checkedurl(){
  var _this_url = location.href;
  var _target_url_arr_1 = ['/elegance/products/'];
  for(var _i = 0; _i < _target_url_arr_1.length; _i++){
    if(_this_url.indexOf(_target_url_arr_1[_i]) != -1){
      if ($.cookie("floating_bnr_cookie1")) {
        $('.banner.js-floating_bnr').remove();
      }
    }
  }
  var _target_url_arr_2 = ['/elegance/collection/ss-discover/'];
  for(var _i = 0; _i < _target_url_arr_2.length; _i++){
    if(_this_url.indexOf(_target_url_arr_2[_i]) != -1){
      if ($.cookie("floating_bnr_cookie2")) {
        $('.banner.js-floating_bnr').remove();
      }
    }
  }
  var _target_url_arr_3 = ['/cruise/products/'];
  for(var _i = 0; _i < _target_url_arr_3.length; _i++){
    if(_this_url.indexOf(_target_url_arr_3[_i]) != -1){
      if ($.cookie("floating_bnr_cookie3")) {
        $('.banner.js-floating_bnr').remove();
      }
    }
  }
}

function trace(_){
  if (typeof window.console === "undefined") {
    window.console = {}
  }
  if (typeof window.console.log !== "function") {
    window.console.log = function (){
    }
  } else {
    console.log(_);
  }
}

// PCのみ
function changeMenuBackground(){
  var _GNAV_HOVER_ARRAY = "body.pape-ele-la_poudre .gnav_products, body.page-cru-feature .gnav_products, body.page-cru-product .gnav_products, body.page-cru-product .gnav_products,body.page-cru-product .gnav_collection,body.page-cru-product .gnav_artists, body.page-cru-collection .gnav_products, body.page-cru-index .gnav_products, body.pape-ele-la_poudre .header,body.page-cru-ss .header,body.page-cru-index .header, body.page-cru-campaign .gnav_products, body.page-cru-campaign .gnav_collection, body.page-cru-campaign .gnav_artists";

  $(_GNAV_HOVER_ARRAY).on('mouseenter',function(){
    $('body').addClass('bg_white');
  });
  $(_GNAV_HOVER_ARRAY).on('mouseleave',function(){
    $('body').removeClass('bg_white');
  });
}


function gnavArtistMeetArtistCheckPc(){
  var _this_hash = location.hash;
  if(_this_hash.indexOf('#anc_meetartits') != -1){
    $('body').addClass('act_meetatrst');
    var _position____ = $('#anc_meetartits').offset().top;
    setTimeout(function (){
      $("html, body").animate({scrollTop:_position____}, 500, "swing");
    },1600);
  }

  $('.gnav__snav--meetartist').on('click', function (){
    location.href = "#anc_meetartits";
  });
}

// // PCのみ
function linkStop(_e) {
  _e.preventDefault ? _e.preventDefault() : _e.returnValue = false;
}

// PCのみ
$('.js_popup_win').bind('click', function() {
  var _popupwin;
  var _url = $(this).attr('data-popup_url');
  var _pop_w = $(this).attr('data-popup_w');
  var _pop_h = $(this).attr('data-popup_h');

  if (_popupwin && _popupwin.closed == false) {
      _popupwin.close();
  }
  _popupwin = window.open(_url, "WindowName", "width=" + _pop_w + ",height=" + _pop_h + ",resizable=yes,scrollbars=yes");
  _popupwin.focus();
  $(this).bind('click', linkStop);
});


// -----------------------------------



// 商品検索
$('.js-search__button').on('click', function (e){
  _current_scrollY = $(window).scrollTop();
  $('.search_wrap').fadeIn(300);
  toggleOpenMenu(e);

  $('.btn_close, .btn_menu_close').on('click', function (e){
    closeMenu(e)
    $('.search_wrap').fadeOut(300);
    $('html, body').prop({scrollTop: _current_scrollY});
  });
})



// SPのみ
$('.js_accrdion_parent button').on('click', function(e){
  var menuButton = e.currentTarget;
  var savMenu = menuButton.closest('li').children[1];

  if (menuButton.closest('li').classList.contains('show')){
    menuButton.closest('li').classList.remove('show');
    menuButton.closest('li').children[1].style.height = '';
  } else {
    menuButton.closest('li').classList.add('show');
    menuButton.closest('li').children[1].style.height = savMenu.scrollHeight + 'px';
  }
});


// SPのみ
function btnScroll(){
  var _scroll = $(window).scrollTop();
  if (_scroll > 0) {
    $('body').addClass('scroll_nav');
  } else {
    $('body').removeClass('scroll_nav');
  }
}


// SP仕様
function gnavArtistMeetArtistCheckSp(){
  var _this_hash = location.hash;
  if (_this_hash.indexOf('#anc_meetartits') != -1) {
    $('body').addClass('act_meetatrst');
    var _position = $('#anc_meetartits').offset().top - 68;
    setTimeout(function (){
      $("html, body").animate({scrollTop:_position}, 0, "swing");
    },400);
  } else {
    $('body').addClass('act_atrists');
  }

  $('.gnav__list--sub_meetarits a').on('click', function (){
    location.href = "/artists/#anc_meetartits";
    document.location.reload(true);
  });
}

// SPのみ
const drawerNav = function() {
  const body = document.querySelector('body');
  const className = 'header-drawer-open'
	const openButton = document.querySelector('#js-menu-button');
  const drawer = document.querySelector('#js-header-drawer');

  function drawerOpen() {
    openButton.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add(className)
  }

  function drawerClose() {
    openButton.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove(className)
  }

  openButton.addEventListener('click', () => {
    if (openButton.getAttribute('aria-expanded') === 'true') {
      drawerClose()
    } else {
      drawerOpen()
    }
  })
}
drawerNav();

// SPのみ
const drawerNavAccordion = function() {
  const accordions = document.querySelectorAll('.js-drawer-accordionButton');

  accordions.forEach(function(accordion) {
    
    function openAccordion() {
      accordion.setAttribute('aria-expanded', 'true');
      accordion.nextElementSibling.setAttribute('aria-hidden', 'false');
    }

    function closeAccordion() {
      accordion.setAttribute('aria-expanded', 'false');
      accordion.nextElementSibling.setAttribute('aria-hidden', 'true');
    }

    accordion.addEventListener('click', () => {
      if (accordion.getAttribute('aria-expanded') === 'true') {
        closeAccordion()
      } else {
        openAccordion()
      }
    })
  })
}
drawerNavAccordion();

// -----------------------------------

// PC / SP 共通
$('a.lap_close').click(function() {
  $('body').addClass('cam_none');
  $('footer div.banner').animate({'height': 'hide'}, 600);

  var _target_url_arr_1 = ['/elegance/products/'];
  for(var _i = 0; _i < _target_url_arr_1.length; _i++){
    if(_this_url.indexOf(_target_url_arr_1[_i]) != -1){
      if ($.cookie("floating_bnr_cookie1")) {
        $('.banner.js-floating_bnr').remove();
      }else{
        $.cookie("floating_bnr_cookie1", "brn close", { path: "/", expires: 1 });
        break;
      }
    }
  }
  var _target_url_arr_2 = ['/elegance/collection/ss-discover/'];
  for(var _i = 0; _i < _target_url_arr_2.length; _i++){
    if(_this_url.indexOf(_target_url_arr_2[_i]) != -1){
      if ($.cookie("floating_bnr_cookie2")) {
        $('.banner.js-floating_bnr').remove();
      }else{
        $.cookie("floating_bnr_cookie2", "brn close", { path: "/", expires: 1 });
        break;
      }
    }
  }
  var _target_url_arr_3 = ['/cruise/products/'];
  for(var _i = 0; _i < _target_url_arr_3.length; _i++){
    if(_this_url.indexOf(_target_url_arr_3[_i]) != -1){
      if ($.cookie("floating_bnr_cookie3")) {
        $('.banner.js-floating_bnr').remove();
      }else{
        $.cookie("floating_bnr_cookie3", "brn close", { path: "/", expires: 1 });
        break;
      }
    }
  }
});



winw = $(window).width();
winh = $(window).height();

var COLLECTION_URL = '/elegance/collection/aw-discover/';

$(function (){
  // PC / SP 共通
  checkedurl();

  if (($('.pc-contents').css('display') == 'block')) {
    headerh = $('header#header').height();
    pageTopNav();
    winCheck();
    changeMenuBackground();
    gnavArtistMeetArtistCheckPc();
  } else {
    btnScroll();
    gnavArtistMeetArtistCheckSp();
  }

  //コレクションの場合
  if ($('footer').length) {
    var _fTop = $('footer').offset().top;
    if(_this_url.indexOf(COLLECTION_URL) != -1){
      if ($(window).scrollTop() < 200) {
        $('footer div.banner').addClass('hide');
      } else if (SCROLL > _fTop) {
  
          $('footer div.banner').removeClass('hide');
        $('footer div.banner').addClass('fixed');
      } else {
        $('footer div.banner').removeClass('hide');
        $('footer div.banner').removeClass('fixed');
      }
    }
  }
});


window.addEventListener('resize', function(){
  winw = $(window).width();
  winh = $(window).height();
  if (($('.pc-contents').css('display') == 'block')) {
    winCheck();
  }
});


window.addEventListener('scroll', function(){
  if (($('.pc-contents').css('display') == 'block')) {
    $(".header").css({
      "left": -$(window).scrollLeft()
    });
    scrollNav();
  } else {
    btnScroll();
  }

  if ($('footer').length) {
    var _fTop = $('footer').offset().top;
    SCROLL = $(window).scrollTop() + $(window).height();
    if ($(window).scrollTop() < 200) {
      //コレクションだけFVに非表示
      if (_this_url.indexOf(COLLECTION_URL) != -1) {
        $('footer div.banner').addClass('fixed');
      }
      if (($('.pc-contents').css('display') == 'block')) {
        $('footer div.banner').addClass('hide');
      }
    } else if (SCROLL > _fTop) {
      $('footer div.banner').removeClass('hide');
      $('footer div.banner').addClass('fixed');
    } else {
      $('footer div.banner').removeClass('hide');
      $('footer div.banner').removeClass('fixed');
    }
  }
});


$('.gnav__snav--meetartist').on('click', function (){
  location.href = "#anc_meetartits";
});


$(window).on("hashchange", function(){
  if (window.innerWidth >= 768 ) {
    gnavArtistMeetArtistCheckPc();
  } else {
    gnavArtistMeetArtistCheckSp();
  }
});


window.addEventListener('load', function(){
  $('body').addClass('load');
  if ($('.p_ele_product_index').length || $('.page-cru-product').length) {
    if($(location).attr('hash')){
      var hash = $(location).attr('hash');
      var link;
      if($('.pc-contents').length &&('.sp-contents').length){
        if (window.outerWidth > 1080) {
          link = '.pc-contents ' + hash
        } else {
          link = '.sp-contents ' + hash
        }
      }
      $("html, body").scrollTop($(link).offset().top);
    }
  }
})

// SPのみ
// Androidのみ明朝体はwebフォントを使用する
if ( navigator.userAgent.indexOf('Android') > 0 ) {
  $("body").addClass("is-android");
};
